import {
  config
} from '../constants';

/**
 * Import constants
 */
const {
  SET_LANGS,
  SET_TITLE,
  SET_SCHEDULE,
  SET_COUNTRY_CD,
  SET_IS_ACTIVE,
  SET_COLLECTION,
  SET_LOCALITY_ID,
  SET_DISTRICT_ID,
  SET_DEFAULT_LANG,
  SET_SELECTED_LANG,
  SET_DISTRICT_LABEL,
  SET_REMINDER_OPTION,
  SET_TEMPLATE_COLOUR,
  SET_SEARCH_AT_FIRST,
  SET_IS_MULTI_DISTRICT,
  SET_WEBAPP_CONFIGURATION,
  SET_IS_PROMPT_MESSAGE_OPEN,
  SET_SHOULD_SEE_DISTRICT_SELECTOR,
} = config;

/**
 * Action creators
 */
const actions = {
  setLangs: (data) => ({ type: SET_LANGS, data }),
  setTitle: (data) => ({ type: SET_TITLE, data }),
  setSchedule: (data) => ({ type: SET_SCHEDULE, data }),
  setCollection: (data) => ({ type: SET_COLLECTION, data }),
  setCountryCode: (data) => ({ type: SET_COUNTRY_CD, data }),
  setIsActive: (data) => ({ type: SET_IS_ACTIVE, data }),
  setLocalityId: (data) => ({ type: SET_LOCALITY_ID, data }),
  setDistrictId: (data) => ({ type: SET_DISTRICT_ID, data }),
  setDefaultLang: (data) => ({ type: SET_DEFAULT_LANG, data }),
  setSelectedLang: (data) => ({ type: SET_SELECTED_LANG, data }),
  setDistrictLabel: (data) => ({ type: SET_DISTRICT_LABEL, data }),
  setSearchAtFirst: (data) => ({ type: SET_SEARCH_AT_FIRST, data }),
  setReminderOption: (data) => ({ type: SET_REMINDER_OPTION, data }),
  setTemplateColour: (data) => ({ type: SET_TEMPLATE_COLOUR, data }),
  setIsMultiDistrict: (data) => ({ type: SET_IS_MULTI_DISTRICT, data }),
  setWebappConfiguration: (data) => ({ type: SET_WEBAPP_CONFIGURATION, data }),
  setIsPromptMessageOpen: (data) => ({ type: SET_IS_PROMPT_MESSAGE_OPEN, data }),
  setShouldSeeDistrictSelector: (data) => ({ type: SET_SHOULD_SEE_DISTRICT_SELECTOR, data }),
};

export const setShouldSeeDistrictSelector = (state) => (dispatch) => dispatch(
  actions.setShouldSeeDistrictSelector(state)
);

export const setCountryCode = (code) => (dispatch) => dispatch(
  actions.setCountryCode(code)
);
export const setIsActive = (isActive) => (dispatch) => dispatch(
  actions.setIsActive(isActive)
);

export const setSelectedLang = (selectedLang) => (dispatch) => dispatch(
  actions.setSelectedLang(selectedLang)
);

export const setLangs = (langs) => (dispatch) => dispatch(actions.setLangs(langs));

export const setWebappConfiguration = (webappConfig) => (dispatch) => dispatch(
  actions.setWebappConfiguration(webappConfig)
);

export const setReminderOption = (reminderOption) => (dispatch) => dispatch(
  actions.setReminderOption(reminderOption)
);

export const setDistrictId = (districtId) => (dispatch) => dispatch(
  actions.setDistrictId(districtId)
);

export const setTitle = (title) => (dispatch) => dispatch(
  actions.setTitle(title)
);

export const setTemplateColour = (templateColour) => (dispatch) => dispatch(
  actions.setTemplateColour((templateColour && templateColour !== 'null') ? templateColour : '')
);

export const setSchedule = (schedule) => (dispatch) => dispatch(
  actions.setSchedule(schedule)
);

export const setLocalityId = (localityId) => (dispatch) => dispatch(
  actions.setLocalityId(localityId)
);

export const setCollection = (collection) => (dispatch) => dispatch(
  actions.setCollection(collection)
);

export const setSearchAtFirst = (searchAtFirst) => (dispatch) => dispatch(
  actions.setSearchAtFirst(searchAtFirst)
);

export const setDefaultLang = (defaultLang) => (dispatch) => dispatch(
  actions.setDefaultLang(defaultLang)
);

export const setIsMultiDistrict = (isMultiDistrict) => (dispatch) => dispatch(
  actions.setIsMultiDistrict(isMultiDistrict)
);

export const setDistrictLabel = (districtLabel) => (dispatch) => dispatch(
  actions.setDistrictLabel(districtLabel)
);

export const setIsPromptMessageOpen = (isPromptMessageOpen) => (dispatch) => dispatch(
  actions.setIsPromptMessageOpen(isPromptMessageOpen)
);
